export const SET_DRUGSTORES = 'DRUGSTORES/SET_DRUGSTORES';
export const SET_LOADER = 'DRUGSTORES/SET_LOADER';
export const SET_LOCATION = 'DRUGSTORES/SET_LOCATION';
export const SET_MAP_CENTER = 'DRUGSTORES/SET_MAP_CENTER';
export const SET_RADIUS = 'DRUGSTORES/SET_RADIUS';
